import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../../common/utils/styles/css/styles';

export default function Suspended() {
  const { t } = useTranslation();
  return (
    <div css={styles.tac}>
      <img alt="" src="/static/images/register/img-registration-rejected.svg" />
      <h1 css={styles.mtm}>{t('signin.message.registration.banned.title', 'Account suspended')}</h1>
      <p>
        {t(
          'signin.message.registration.banned.subtitle',
          'Your account has been suspended due to a violation of our Terms and Conditions.'
        )}
      </p>
    </div>
  );
}
